import React, {} from 'react';
import {
    css,
    Grid,
    Header,
    Div,
} from "@bdfx/fukit"
import { Pie } from 'react-chartjs-2'
import ctrans from "../../common/trans"
import Chart from "chart.js"
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Audit } from '@bdfx/audit-api/types';
Chart.pluginService.register(ChartDataLabels);

let init = []
        
Chart.pluginService.register({
    afterDatasetsUpdate: function(chartInstance) {
        // If `hiddenSlices` has been set.
        if (init.indexOf(chartInstance.id) === -1 && chartInstance.config.data.hiddenSlices !== undefined) {

          for (let i = 0; i < chartInstance.data.datasets.length; ++i) {
            chartInstance.config.data.hiddenSlices.forEach(function(index) {
                if(chartInstance.getDatasetMeta(i).data?.[index]) {
                    chartInstance.getDatasetMeta(i).data[index].hidden = true;
                }
            });
          }
          init.push(chartInstance.id)
          chartInstance.update();
        }
      }
  });

class Pies extends React.PureComponent<{ data: Audit['result'] }, {}> {
   
    chartEl = null

    constructor(props) {
        super(props)
        this.chartEl = React.createRef();
        init = []
    }

    render() {


    const getBiddingData = () => {
        const {
            not_paired,
            ppc_off,
            bidding_enabled_without_me,
            paired,
        } = this.props.data
        return  ({
            labels: [ ctrans("not_paired_short"), ctrans("no_bidding"),  ctrans("out_of_bidding"), ctrans("in_bidding") ],
            datasets: [{
                data: [  not_paired,  ppc_off, bidding_enabled_without_me,  paired - ppc_off - bidding_enabled_without_me ],
                backgroundColor: [ "#ccc", "#aaa", "#ED553B", "#3CAEA3" ]
            }],
            hiddenSlices: [ 0 ]

        })
    }
    const getTopData = () => {
        const {
            not_paired,
            paired,
            top_with_cart,
            top_without_cart,
        } = this.props.data
        return ({
            labels: [ ctrans("not_paired_short"), ctrans("others"), ctrans("no_cart"), ctrans("with_cart")],
            datasets: [{
                data: [ not_paired, paired - top_with_cart - top_without_cart, top_with_cart, top_without_cart,  ],
                backgroundColor: [ "#ccc", "#888",  "#20539B", "#F6D55C",] 

            }],
            hiddenSlices: [ 0, 1 ]

        })
    }
    const getOptions = () => ({
        plugins: {
            datalabels: {
              display: true,
              color: "white",
              font: {
                weight: "bold",
              },
              formatter: (value,a) => {
                const percent = Math.round(value * 100 / ( this.props.data.paired + this.props.data.not_paired))
                if(percent > 1) {
                  return  percent + " %"
                } else {
                  return ""
                }
              }
            }
          },
        legend: {
            reverse: true,
            // align: "start",
            // fullWidth: false,
            // labels: {
            //     boxWidth: 15,
            // },
            // onClick: function(e, legendItem, legend, l) {
            //     const index = legendItem.index;
            //     console.log(index, chartEl.current.chartInstance.legend)
            //     const ci = chartEl.current.chartInstance.legend.legendItems[index];
            //     if (ci) {
            //         // ci.hide(index);
            //         legendItem.hidden = true;
            //     } else {
            //         // ci.show(index);
            //         legendItem.hidden = false;
            //     }
            // }
        },        
        // scales: {
        //     yAxes: [{
        //         stacked: true,
        //         ticks: {
        //             fontStyle: "bold",
        //             callback: formatInt,
        //         },
        //         scaleLabel: {
        //             display: true,
        //             labelString: ctrans("products_count"),
        //         },
        //     }],
        //     xAxes: [{
        //         stacked: true,
        //         gridLines: {
        //             display: false,
        //         },
        //         ticks: {
        //             fontStyle: "bold",
        //             callback: function(value) {
        //                 if(value.length > 8) {
        //                     return value.substr(0, 8)+"..";//truncate
        //                 }
        //                 return value
        //             },    
        //         },
        //     }]

        // },
    })
    
    return (
        <Style className="section pies">
            <Grid cols="1fr 1fr" gap="50px">
                <Div>
                    <Header type={2}>
                        {ctrans("products_in_bidding")}
                    </Header>
                    <Div marginTop="-30px" width="100%" className="pie-graph">
                        <Pie height={150} options={getOptions()} data={getBiddingData()} />
                    </Div>
                </Div>

                <Div>
                    <Header type={2}>
                        {ctrans("products_top_position")}
                    </Header>
                    <Div marginTop="-30px" width="100%" className="pie-graph">
                        <Pie height={150} options={getOptions()} data={getTopData()} ref={this.chartEl} />
                    </Div>
                </Div>
            </Grid>
        </Style> 
  );
}
}

const Style = css("div")({
    background: "#fff",
    paddingBottom: "150px",
    "> div": {
        maxWidth: "1200px",
        margin: "auto",
        position: "relative",
        zIndex: 1,
    },
    ".fuk-header.h2": {
        marginTop: "0",
        marginBottom: "1.5em",
    },
    "@media only screen and (max-width: 1000px)": {
        ".fuk-grid": {
            display: "block",
        }
    },
})

export default Pies;
